"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const prop_types_1 = __importDefault(require("prop-types"));
const classnames_1 = __importDefault(require("classnames"));
const react_jss_1 = __importDefault(require("react-jss"));
const viewTitle_styles_1 = __importDefault(require("./viewTitle.styles"));
class ViewTitle extends react_1.Component {
    constructor() {
        super(...arguments);
        this.render = () => {
            const { classes, className, children, title } = this.props;
            return (jsx_runtime_1.jsxs("div", Object.assign({ className: classnames_1.default(classes.root, className) }, { children: [jsx_runtime_1.jsx("div", Object.assign({ className: classes.title }, { children: title }), void 0), children] }), void 0));
        };
    }
}
ViewTitle.propTypes = {
    classes: prop_types_1.default.object.isRequired,
    title: prop_types_1.default.string.isRequired,
    children: prop_types_1.default.node,
    className: prop_types_1.default.string
};
ViewTitle.defaultProps = {
    className: null,
    children: null
};
exports.default = react_jss_1.default(viewTitle_styles_1.default)(ViewTitle);
//# sourceMappingURL=index.js.map